import type { IQuaternion, ITransformRT3, IVector3 } from '@seddi/math-v2';

import type { Viewer } from '../components/AppViewer/AppViewer';
import type { AppViewerTool } from '../components/AppViewer/appViewerTool';
import type { TCamera } from '../types/protocolTypes';
import { computeCameraLookAtFromTransform } from '../viewer/cameraLookAtFromTransform';

const degToRad = (deg: number): number => {
  return deg * (Math.PI / 180.0);
};

const radToDeg = (rad: number): number => {
  return rad * (180.0 / Math.PI);
};

const setCameraFromTransform = async (viewer: Viewer, transform: ITransformRT3) => {
  const lookAt = computeCameraLookAtFromTransform(transform);
  const tool = viewer.tool as unknown as AppViewerTool;
  tool.lookAt(lookAt.origin, lookAt.target);
};

const ViewFarDef = 10.0;
const ViewFovDef = degToRad(20.0);
const ViewNearDef = 0.1;
const ViewTranslationDef: IVector3 = { x: 0.0, y: 1.2, z: 3.0 };
const ViewRotationDef: IQuaternion = { x: 0.0, y: 0.0, z: 0.0, w: 1.0 };

export const setCamera = async (viewer: Viewer, desc: TCamera) => {
  const far = desc.far ?? ViewFarDef;
  const fov = desc.fov ?? ViewFovDef;
  const near = desc.near ?? ViewNearDef;
  const rotation = desc.transform?.rotation ?? ViewRotationDef;
  const translation = desc.transform?.translation ?? ViewTranslationDef;
  // update transform
  const transform: ITransformRT3 = { rotation, translation };
  setCameraFromTransform(viewer, transform);
  // update projection matrix
  const camera = viewer.camera;
  camera.far = far;
  camera.fov = radToDeg(fov);
  camera.near = near;
  camera.updateProjectionMatrix();
};
